import React, { useState } from 'react';
import ViewMore from '../../pages/Inventory/ViewMore';
import { observer } from 'mobx-react';
import { ViewMoreStock } from '../../pages';


const ViewMoreStockContainer = ({ closeModal }) => {
	const [openViewMoreModal, setOpenViewMoreModal ] = useState(true);
	const [ newEditModal, setNewEditModal] = useState(false);

	const handleCancel = () => {
		setOpenViewMoreModal(false);
	};

	const createNewEditModal = () => {
		setNewEditModal(true);
	};

	const goBack = () => {
		if (newEditModal) {
			setNewEditModal(false);
		} else closeModal()
	}

    return (
        <ViewMoreStock
        closeModal={closeModal}
        goBack={goBack}
        handleCancel={handleCancel}
		newEditModal={newEditModal}
		createNewEditModal={createNewEditModal}
        />
    )
}

export default observer(ViewMoreStockContainer);